import React from "react";
import { Link } from "react-router-dom";
import { getPayeeParts } from "./paymentPayee";

const CELL_STYLE = { fontSize: "1em", lineHeight: "1.49em" };

/**
 * The seven columns that are identical across the EFT / Check / Debit reports.
 * The payment-identifier, status and any trailing columns are supplied by the
 * caller as ready-made <td> nodes.
 */
export default function PaymentReportRow({
    program,
    patientID,
    firstName,
    lastName,
    dob,
    memberNum,
    dos,
    claimData,
    amount,
    statusDate,
    idCell,
    statusCell,
    trailingCells = null,
}) {
    const { providerFirst, providerLast, address_1, address_2, city, state, zipcode } = getPayeeParts(claimData);

    function viewPatient() {
        window.localStorage.setItem("xrefID", parseInt(patientID));
    }

    return (
        <tr>
            <td style={CELL_STYLE}>{program}</td>
            <td style={CELL_STYLE}>
                <Link onClick={viewPatient} to="../patient-informations">
                    {firstName} {lastName}
                </Link>
            </td>
            <td style={CELL_STYLE}>{dob}</td>
            <td style={CELL_STYLE}>{memberNum}</td>
            <td style={CELL_STYLE}>{dos}</td>
            <td style={CELL_STYLE}>
                {providerFirst} {providerLast} {address_1}{" "}
                {address_2 != "" && address_2 != null ? (
                    <>
                        <br />
                        {address_2},{" "}
                    </>
                ) : (
                    <></>
                )}
                <br />
                {city}, {state} {zipcode}
            </td>
            <td style={CELL_STYLE}>${amount}</td>
            {idCell}
            <td style={CELL_STYLE}>{statusDate}</td>
            {statusCell}
            {trailingCells}
        </tr>
    );
}

export { CELL_STYLE };

/** Status column used by the Check and Debit reports. */
export function SimpleStatusCell({ paidDate, status }) {
    return (
        <td style={CELL_STYLE}>
            {paidDate != null
                ? "Paid"
                : status === "Maximizer-Hold" || status == "Max-Ben EDI Hold" || status == "Max-Ben Hold" || status == "exception"
                ? "Pending"
                : status}
        </td>
    );
}

/** Renders the current page of a PAYMENT_REPORTS result, or nothing. */
export function mapPaymentReports(data, offset, limit, renderRow) {
    return data && data.providerreports && data.providerreports.slice(offset, limit).map(renderRow);
}




